import { render } from "./TwoFactorSecurity.vue?vue&type=template&id=bb938e7c&scoped=true"
import script from "./TwoFactorSecurity.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TwoFactorSecurity.vue?vue&type=script&charset=utf-8&lang=js"

import "./TwoFactorSecurity.vue?vue&type=style&index=0&id=bb938e7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb938e7c"]])

export default __exports__